import { createElementBlock as e, openBlock as o, createElementVNode as l } from "vue";
import r from "./index289.js";
const c = {}, n = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function s(a, t, p, d, i, f) {
  return o(), e("svg", n, t[0] || (t[0] = [
    l("path", {
      fill: "currentColor",
      d: "M12 2.25c5.278 0 9.593 4.2 9.746 9.474l.004.276c0 5.278-4.2 9.593-9.474 9.746L12 21.75c-5.278 0-9.593-4.2-9.746-9.474L2.25 12c0-5.278 4.2-9.593 9.474-9.746ZM5.68 6.694l-.14.171a8.2 8.2 0 0 0-1.79 5.124l.004.255c.128 4.453 3.78 8.006 8.235 8.006l.255-.004a8.215 8.215 0 0 0 5.062-1.927.656.656 0 0 1-.095-.06l-.084-.072L5.813 6.873a.75.75 0 0 1-.133-.18ZM12 3.75l-.244.004A8.215 8.215 0 0 0 6.694 5.68a.656.656 0 0 1 .095.06l.084.072 11.314 11.314a.75.75 0 0 1 .133.18 8.206 8.206 0 0 0 1.93-5.296l-.004-.255A8.25 8.25 0 0 0 12 3.75Z"
    }, null, -1)
  ]));
}
const u = /* @__PURE__ */ r(c, [["render", s]]);
export {
  u as default
};
